export default __webpack_public_path__ + "static/media/legend-before.ea804524.jpg";